import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const FileOutlinedSvg = () => (
  <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="path-1-inside-1_4072_46720" fill="white">
      <rect y="0.5" width="17.29" height="20.82" rx="1" />
    </mask>
    <rect y="0.5" width="17.29" height="20.82" rx="1" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" mask="url(#path-1-inside-1_4072_46720)" />
    <mask id="path-2-inside-2_4072_46720" fill="white">
      <rect x="3" y="4.5" width="11" height="2" rx="0.3" />
    </mask>
    <rect
      x="3"
      y="4.5"
      width="11"
      height="2"
      rx="0.3"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4 6 8"
      mask="url(#path-2-inside-2_4072_46720)"
    />
    <mask id="path-3-inside-3_4072_46720" fill="white">
      <rect x="3" y="8.5" width="7" height="2" rx="0.3" />
    </mask>
    <rect
      x="3"
      y="8.5"
      width="7"
      height="2"
      rx="0.3"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeDasharray="2 4 6 8"
      mask="url(#path-3-inside-3_4072_46720)"
    />
  </svg>
);

const FileOutlined = (props: IIconProps) => <Icon component={FileOutlinedSvg} {...props} />;

export default FileOutlined;
